import React from "react";
import { Box, Typography, Autocomplete, TextField, Chip } from "@mui/material";
import { styles } from "./MultiSelectComponentStyles"

export const MultiSelectComponent = ({ options, value, onChange, label, placeholder }: any) => (
    <Box sx={styles.multiSelectBox}>
        <Typography variant="h6" fontSize={16} fontWeight={500} mt={1} gutterBottom>
            {label}
        </Typography>
        <Autocomplete
            multiple
            fullWidth
            options={options}
            getOptionLabel={(option) => option.title}
            size="small"
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder={"" || placeholder}
                    sx={styles.inputStyle}
                />
            )}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        label={option.title}
                        {...getTagProps({ index })}
                        sx={styles.tagStyle}
                    />
                ))
            }
        />
    </Box>
);
